import React from 'react';

const AboutSection = () => {
  return (
    <section className="py-16 relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 right-20 w-80 h-80 bg-brand-primary/10 rounded-full blur-3xl animate-float"></div>
        <div className="absolute bottom-20 left-20 w-64 h-64 bg-brand-secondary/10 rounded-full blur-3xl animate-float" style={{animationDelay: '2s'}}></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-brand-dark/5 rounded-full blur-3xl animate-pulse"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-8 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-20">
          {/* Left: Enhanced Image Section */}
          <div className="flex-1 flex justify-center">
            <div className="relative group">
              {/* Main Image */}
              <div className="relative">
                <img 
                  src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop&crop=face" 
                  alt="StarAI Team" 
                  className="rounded-full w-80 h-80 object-cover shadow-2xl border-8 border-white group-hover:scale-105 transition-transform duration-700"
                />
                
                {/* Floating decorative elements */}
                <div className="absolute -top-6 -right-6 w-24 h-24 bg-brand-primary rounded-full opacity-40 animate-float"></div>
                <div className="absolute -bottom-6 -left-6 w-20 h-20 bg-brand-secondary rounded-full opacity-40 animate-float" style={{animationDelay: '1s'}}></div>
                <div className="absolute top-1/2 -right-8 w-16 h-16 bg-brand-dark rounded-full opacity-30 animate-float" style={{animationDelay: '2s'}}></div>
                
                {/* Glowing ring effect */}
                <div className="absolute inset-0 rounded-full border-4 border-brand-primary/30 animate-pulse-glow"></div>
              </div>
              
              {/* Stats overlay */}
              <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2">
                <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-4 shadow-xl border border-white/20">
                  <div className="flex space-x-6">
                    <div className="text-center">
                      <div className="text-2xl font-bold text-brand-primary">50+</div>
                      <div className="text-xs text-gray-600">Doanh nghiệp</div>
                    </div>
                    <div className="text-center">
                      <div className="text-2xl font-bold text-brand-secondary">200+</div>
                      <div className="text-xs text-gray-600">Chuyên gia</div>
                    </div>
                    <div className="text-center">
                      <div className="text-2xl font-bold text-brand-dark">95%</div>
                      <div className="text-xs text-gray-600">Hài lòng</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Right: Enhanced Content */}
          <div className="flex-1 space-y-8">
            {/* Header */}
            <div className="space-y-6">
              {/* <div className="inline-block px-6 py-3 bg-gradient-to-r from-blue-100 to-purple-100 text-blue-700 font-semibold rounded-full text-sm shadow-lg">
                VỀ CHÚNG TÔI
              </div> */}
              
              <h2 className="text-display-3 font-display font-black leading-tight tracking-tighter">
                <span className="text-brand-dark">Câu chuyện</span><br />
                <span className="text-gradient">StarAI</span>
              </h2>
              
              <p className="text-body-large text-gray-600 leading-relaxed max-w-2xl font-body">
                Công ty Cổ phần Tư vấn Ngôi Sao AI (StarAI) chuyên về tư vấn và đào tạo ứng dụng Trí tuệ nhân tạo trong doanh nghiệp. Chúng tôi tiên phong với chương trình "Train the Trainer về AI" - nền tảng để hình thành hệ sinh thái nhân sự biết và dạy AI tại Việt Nam.
              </p>
            </div>
            
            {/* Enhanced Innovation Process */}
            <div className="glass rounded-3xl p-8 shadow-xl">
              <h3 className="text-2xl font-bold gradient-text mb-6">Quy trình đổi mới sáng tạo</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex items-start space-x-4 group">
                  <div className="w-12 h-12 bg-brand-primary text-white rounded-xl flex items-center justify-center text-lg font-bold flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                    1
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800 text-lg mb-2">Khảo sát thực tiễn</h4>
                    <p className="text-gray-600 leading-relaxed">Đánh giá hiện trạng nhận thức và ứng dụng AI tại doanh nghiệp</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4 group">
                  <div className="w-12 h-12 bg-brand-secondary text-white rounded-xl flex items-center justify-center text-lg font-bold flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                    2
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800 text-lg mb-2">Thiết kế sản phẩm</h4>
                    <p className="text-gray-600 leading-relaxed">Phát triển sản phẩm đào tạo, tư vấn theo từng ngành</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4 group">
                  <div className="w-12 h-12 bg-brand-dark text-white rounded-xl flex items-center justify-center text-lg font-bold flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                    3
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800 text-lg mb-2">Triển khai thực tế</h4>
                    <p className="text-gray-600 leading-relaxed">Thực hiện đào tạo và tư vấn trực tiếp tại doanh nghiệp</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4 group">
                  <div className="w-12 h-12 bg-brand-primary text-white rounded-xl flex items-center justify-center text-lg font-bold flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                    4
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800 text-lg mb-2">Đánh giá kết quả</h4>
                    <p className="text-gray-600 leading-relaxed">Đo lường hiệu quả và tối ưu hóa quy trình</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Enhanced Contact Section */}
            <div className="bg-brand-primary/10 rounded-3xl p-6 border border-brand-primary/20">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-brand-primary rounded-xl flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-bold text-gray-800 text-lg mb-1">Sẵn sàng chuyển đổi?</h4>
                  <p className="text-gray-600">Liên hệ ngay để được tư vấn miễn phí</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection; 